import React, { useState } from 'react';
import { Gamepad2, SearchX } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import AuthDialog from '../components/AuthDialog';
import { Button } from '../components/ui/button';
import { originalGames } from '../components/originals/games';
import { OriginalsToolbar } from '../components/originals/OriginalsToolbar';
import { OriginalsGameCard } from '../components/originals/OriginalsGameCard';
import { OriginalsInfoDialog } from '../components/originals/OriginalsInfoDialog';
import '../components/originals/originals.css';

export default function Originals() {
  const [query, setQuery] = useState('');
  const [sort, setSort] = useState('default');
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login');

  const games = originalGames.filter((game) => game.name.toLowerCase().includes(query.trim().toLowerCase()));
  if (sort !== 'default') games.sort((a, b) => sort === 'az' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name));

  return (
    <div className="originals-page" data-testid="originals-page">
      <Sidebar onAuth={(mode) => { setAuthMode(mode); setAuthOpen(true); }} />
      <div className="content-shift pt-16">
        <main className="originals-main">
          <header className="originals-heading">
            <div>
              <p className="originals-eyebrow" data-testid="originals-brand">GVRewards</p>
              <h1 className="rewards-page-title text-4xl sm:text-5xl lg:text-6xl" data-testid="originals-title"><Gamepad2 aria-hidden="true" />Originals</h1>
            </div>
            <div className="originals-heading-aside"><OriginalsInfoDialog /><p className="originals-credit-note" data-testid="originals-credit-notice">V credits only <span aria-hidden="true">·</span> No cash value</p></div>
          </header>
          <OriginalsToolbar query={query} setQuery={setQuery} sort={sort} setSort={setSort} count={games.length} />
          {games.length ? (
            <section className="originals-grid" aria-label="Originals games" data-testid="originals-game-grid">
              {games.map((game, index) => <OriginalsGameCard key={game.id} game={game} index={index} />)}
            </section>
          ) : (
            <section className="originals-empty" data-testid="originals-empty-state">
              <SearchX size={32} aria-hidden="true" />
              <h2 data-testid="originals-empty-title">No games found</h2>
              <p data-testid="originals-empty-query">No matches for “{query.trim()}”.</p>
              <Button variant="outline" onClick={() => setQuery('')} data-testid="originals-reset-search">Clear search</Button>
            </section>
          )}
        </main>
        <Footer />
      </div>
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} mode={authMode} setMode={setAuthMode} />
    </div>
  );
}